import { ADD_SETTINGS } from "../../Constants/reduxKeys";

export function setSettings(data) {
	return {
		type: ADD_SETTINGS,
		payload: data,
	};
}
